import gql from 'graphql-tag';

// Antecipa no passo 1 o que antes so aparecia no submit final: quem ja tem
// conta descobria depois de preencher os tres passos.
export const QUERY_REGISTRATION_EMAIL_AVAILABLE = gql`
  query registrationEmailAvailable($email: String!) {
    registrationEmailAvailable(email: $email)
  }
`;

// A coordenada vem pelo Rails, e nao direto do browser: a politica do
// Nominatim exige identificacao da aplicacao, cache e no maximo uma
// requisicao por segundo.
export const QUERY_GEOCODE_ADDRESS = gql`
  query geocodeAddress($zipcode: String!, $street: String, $city: String, $state: String) {
    geocodeAddress(zipcode: $zipcode, street: $street, city: $city, state: $state) {
      latitude
      longitude
    }
  }
`;
